import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

const iconContainerClasses = [
  'bg-transparent',
  'border',
  'flex',
  'items-center',
  'justify-center',
  'rounded-md',
  'size-6',
].join(' ');

const AddWorkspaceButton = () => (
  <DropdownMenuItem className="gap-2 p-2">
    <div className={iconContainerClasses}>
      <FontAwesomeIcon icon={faPlus} />
    </div>

    <div className="text-muted-foreground font-medium">Add workspace</div>
  </DropdownMenuItem>
);

export default AddWorkspaceButton;
